import { Box, IconButton, Text } from '@chakra-ui/react'
import React from 'react'
import { FaShoppingCart } from 'react-icons/fa'
import { useAppDispatch } from 'src/hooks/store'
import { openCartDrawer } from 'src/redux/cart/slice'
import { useCart } from 'src/services/api/queries/queries'
import { Styles } from 'src/types/types'

const CartButton: React.FC = () => {
  const dispatch = useAppDispatch()
  const handleOpenModal = () => dispatch(openCartDrawer())
  const { data } = useCart()
  const cartItemsLength = data?.items_count ?? 0

  return (
    <Box position='relative'>
      <IconButton
        aria-label='Open Cart'
        icon={<FaShoppingCart style={styles.icon} />}
        variant='ghost'
        onClick={handleOpenModal}
        size='lg'
        color='gray'
      />
      {cartItemsLength > 0 && (
        <Box style={styles.cartCount}>
          <Text fontSize='xs' color='white'>
            {cartItemsLength}
          </Text>
        </Box>
      )}
    </Box>
  )
}

const styles: Styles = {
  icon: {
    fontSize: '34px',
  },
  cartCount: {
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: 'red',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

export default CartButton
